import React from 'react';
import './StatsBar.css';

const StatsBar = ({ stats }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const getROIColor = (roi) => {
    if (roi > 10) return '#00ff88';
    if (roi > 0) return '#ffaa00';
    return '#ff4444';
  };

  return (
    <div className="stats-bar">
      <div className="stat-item">
        <div className="stat-value">{stats.totalBets || 0}</div>
        <div className="stat-label">Total Bets</div>
      </div>
      
      <div className="stat-divider"></div>
      
      <div className="stat-item">
        <div className="stat-value">{formatCurrency(stats.totalWagered || 0)}</div>
        <div className="stat-label">Wagered</div>
      </div>
      
      <div className="stat-divider"></div>
      
      <div className="stat-item">
        <div 
          className="stat-value"
          style={{ color: (stats.totalProfit || 0) >= 0 ? '#00ff88' : '#ff4444' }}
        >
          {formatCurrency(stats.totalProfit || 0)}
        </div>
        <div className="stat-label">Profit/Loss</div>
      </div>
      
      <div className="stat-divider"></div>
      
      <div className="stat-item">
        <div className="stat-value">{Number(stats.winRate || 0).toFixed(1)}%</div>
        <div className="stat-label">Win Rate</div>
      </div>
      
      <div className="stat-divider"></div>
      
      <div className="stat-item">
        <div 
          className="stat-value"
          style={{ color: getROIColor(stats.roi || 0) }}
        >
          {stats.roi > 0 ? '+' : ''}{Number(stats.roi || 0).toFixed(1)}%
        </div>
        <div className="stat-label">ROI</div>
      </div>
    </div>
  );
};

export default StatsBar;
